export default __webpack_public_path__ + "static/media/ErrorIcon.23e8dd63.svg";